module.exports = __webpack_public_path__ + "media/images/river/start-from-scratch-c80a4d92ccdd62630922950b34c49267.jpg";